import { PermissionCode, ResourceCode } from '@/const/code'

export default [
  {
    path: '/student-allowance',
    name: 'studentAllowance',
    component: () => import('@/views/student-allowance/StudentAllowance.vue'),
    meta: {
      pageTitle: 'Danh sách Sinh viên hưởng trợ cấp sư phạm',
      breadcrumb: [
        {
          text: 'Công tác Học sinh - Sinh viên',
          active: false,
        },
        {
          text: 'Danh sách SV hưởng trợ cấp sư phạm',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.STUDENTALLOWANCE,
    },
  },
]
